import React, { useState, useEffect } from 'react'
import { supabase } from '../../supabaseClient'

function AdminDashboard() {
  const [stats, setStats] = useState({
    totalLures: 0,
    totalVariants: 0,
    totalColors: 0,
    totalBrands: 0,
    colorsByBrand: []
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchStats()
  }, [])

  const fetchStats = async () => {
    try {
      // Get total base lures
      const { count: lureCount } = await supabase
        .from('base_lures')
        .select('*', { count: 'exact', head: true })

      // Get total variants
      const { count: variantCount } = await supabase
        .from('lure_variants')
        .select('*', { count: 'exact', head: true })

      // Get total colors
      const { count: colorCount } = await supabase
        .from('colors')
        .select('*', { count: 'exact', head: true })

      // Get total brands
      const { count: brandCount } = await supabase
        .from('brands')
        .select('*', { count: 'exact', head: true })

      // Get colors by brand
      const { data: colorsByBrand } = await supabase
        .from('colors')
        .select(`
          brand_id,
          brands (brand_name)
        `)

      // Count colors per brand
      const brandColorCounts = {}
      colorsByBrand?.forEach(item => {
        const brandName = item.brands?.brand_name
        if (brandName) {
          brandColorCounts[brandName] = (brandColorCounts[brandName] || 0) + 1
        }
      })

      const colorsByBrandArray = Object.entries(brandColorCounts).map(([brand, count]) => ({
        brand,
        count
      }))

      setStats({
        totalLures: lureCount || 0,
        totalVariants: variantCount || 0,
        totalColors: colorCount || 0,
        totalBrands: brandCount || 0,
        colorsByBrand: colorsByBrandArray
      })

      setLoading(false)
    } catch (error) {
      console.error('Error fetching stats:', error)
      setLoading(false)
    }
  }

  if (loading) {
    return <div className="loading">Loading dashboard...</div>
  }

  return (
    <div className="admin-dashboard">
      <h1>Admin Dashboard</h1>
      
      {/* Stats Grid */}
      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="stat-number">{stats.totalLures}</div>
          <div className="stat-label">Base Lures</div>
        </div>
        <div className="admin-stat-card">
          <div className="stat-number">{stats.totalVariants}</div>
          <div className="stat-label">Total Variants</div>
        </div>
        <div className="admin-stat-card">
          <div className="stat-number">{stats.totalColors}</div>
          <div className="stat-label">Total Colors</div>
        </div>
        <div className="admin-stat-card">
          <div className="stat-number">{stats.totalBrands}</div>
          <div className="stat-label">Brands</div>
        </div>
      </div>

      {/* Colors by Brand */}
      <div className="admin-section">
        <h2>Colors by Brand</h2>
        <div className="brand-color-list">
          {stats.colorsByBrand.map(item => (
            <div key={item.brand} className="brand-color-item">
              <span className="brand-name">{item.brand}</span>
              <span className="color-count">{item.count} colors</span>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="admin-section">
        <h2>Quick Actions</h2>
        <div className="quick-actions">
          <button className="btn-admin-action" onClick={() => window.location.href = '/admin/add-lure'}>
            ➕ Add New Lure
          </button>
          <button className="btn-admin-action" onClick={() => window.location.href = '/admin/manage-colors'}>
            🎨 Manage Colors
          </button>
          <button className="btn-admin-action" onClick={() => window.location.href = '/admin/manage-brands'}>
            🏢 Manage Brands
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard